import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DigitDateDirective } from './digit-date.directive';
import { DigitAddCommasDirective } from './digit-add-commas.directive';
import { AlphabetOnlyDirective } from './alphabet-only.directive';
import { AlphanumericOnly } from './alphanumeric.directive';
import { DigitOnlyDirective } from './digit-only.directive';
import { DigitAddMinusCommasDirective } from './digit-add-minus-commas.directive';

@NgModule({
  declarations: [DigitDateDirective, DigitAddCommasDirective, DigitOnlyDirective, AlphanumericOnly, AlphabetOnlyDirective, DigitAddMinusCommasDirective],
  imports: [CommonModule],
  exports: [DigitDateDirective, DigitAddCommasDirective, DigitOnlyDirective, AlphanumericOnly, AlphabetOnlyDirective, DigitAddMinusCommasDirective],
})
export class DirectivesModule {}
